import React from 'react';

interface Props {
    children: React.ReactNode;
    width: number;
    height: number;
    iconBackground: string | null;
}

// Renders iconBackground as a real CSS background behind the skin icon. Using a
// background-image (instead of a sibling <img>) guarantees it always paints
// behind the children — it can never end up on top of the skin picture.
const BackgroundWrapper = ({ children, iconBackground, width, height }: Props) => {
    return (
        <div
            style={{
                width,
                height,
                ...(iconBackground
                    ? {
                          backgroundImage: `url("${iconBackground}")`,
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                      }
                    : {}),
            }}
            className={'relative shrink-0 flex items-center justify-center'}
        >
            {children}
        </div>
    );
};

export default BackgroundWrapper;
